// removed by extract-text-webpack-plugin
module.exports = {"base":"ButtonSimple_base--1DwII","isContrast":"ButtonSimple_isContrast--1QTN2","isExternal":"ButtonSimple_isExternal--K_HEz","isGlow":"ButtonSimple_isGlow--3Pb1l","isDisabled":"ButtonSimple_isDisabled--1lRP9","messages":"ButtonSimple_messages--Kkan9"};


//////////////////
// WEBPACK FOOTER
// ./components/ButtonSimple/ButtonSimple.scss
// module id = 2245
// module chunks = 11